import Layout from 'routes/Layout';
import Route from 'routes/Route';
import Home from 'pages/Home';
import NotFound from 'pages/NotFound';

export default {
  root: {
    route: Route,
    path: '/:brand?',
    component: Home,
    layout: Layout,
  },
  noMatch: {
    route: Route,
    component: NotFound,
    layout: Layout,
  },
};
